export let Console = {
    path: 'console',
    name: 'console',
    meta: {
        roleCode: '001',
    },
    component: () =>
        import(
            /* webpackChunkName: "console-page" */ '@/views/back-stage/console/console-page.vue'
        ),
};
